import angular from 'angular'
import _ from 'lodash'

class QuotationFormConsumptionController {
    /** @ngInject */
    constructor($uibModal, $timeout, DeviceChecker, ContractDraft, ErrorCatcher) {
        this.$uibModal = $uibModal
        this.$timeout = $timeout
        this.isMobile = DeviceChecker.isMobile
        this.contractDraftService = ContractDraft
        this.errorCatcher = ErrorCatcher
        this.inseeCodes = []
        this.popoverIsOpen = false
    }

    $onChanges(changes) {
        if (_.isEmpty(this.consumptionForm)) {
            this.consumptionForm = angular.copy(this.store.consumptionView.consumptionForm)
        }
        const isOpenCurrentValue = _.get(changes, 'store.currentValue.consumptionView.isPostCodeIneligible')
        const isOpenPreviousValue = _.get(changes, 'store.previousValue.consumptionView.isPostCodeIneligible')
        const samePreviousValue = isOpenCurrentValue && isOpenPreviousValue
        if (isOpenCurrentValue && !samePreviousValue) {
            this.$uibModal.open({ component: 'quotationModalIneligibility' })
        }
        if (_.get(changes, 'store.currentValue.consumptionView.postCodeValidation.inseecode') !== _.get(changes, 'store.previousValue.consumptionView.postCodeValidation.inseecode')) {
            this.inseeCodes = _.keys(_.get(changes, 'store.currentValue.consumptionView.postCodeValidation.inseecode', []))
            if (this.inseeCodes.length === 1) {
                this.consumptionForm.citycode = this.inseeCodes[0]
            }
        }
    }

    $onInit() {
        this.validatePostCode(this.store.consumptionView.consumptionForm.postcode)
    }

    validatePostCode(choosen_post_code) {
        this.updateForm()
        const POST_CODE_LENGTH = 5
        if (choosen_post_code && choosen_post_code.length === POST_CODE_LENGTH) {
            this.onDispatch({
                $event: (dispatch) => {
                    dispatch({ type: 'VALIDATE_POST_CODE', choosen_post_code })
                    this.contractDraftService.checkPostCode({ id: choosen_post_code, return: 'inseecode' }).$promise
                    .then((postCodeResult) => {
                        dispatch({ type: 'VALIDATE_POST_CODE_DONE', choosen_post_code, postCodeResult })
                    })
                    .catch((error) => {
                        this.errorCatcher.catchError(error)
                        dispatch({ type: 'VALIDATE_POST_CODE_FAIL', choosen_post_code, error })
                    })
                },
            })
        } else {
            this.onDispatch({ $event: { type: 'VALIDATE_POST_CODE_INITIAL' } })
        }
    }

    checkIdProviderCalendar(id) {
        if (_.get(this.store, 'consumptionView.postCodeValidation.eligible', false)) {
            this.consumptionForm.calendar = id
            this.consumptionForm.declaredAnnualCons = {}
            this.updateForm()
        }
    }

    isSubmitEnabled() {
        if (!_.get(this.store, 'consumptionView.postCodeValidation.eligible', false)) {
            return false
        }
        if (_.isEmpty(this.consumptionForm.calendar)) {
            return false
        }
        if (!_.isNumber(this.consumptionForm.power)) {
            return false
        }
        if (this.store.isLandscapeDone === false) {
            const consNotDefined = _.some(
                _.get(this.store, ['tariffOptions', this.consumptionForm.calendar, 'tempClass']),
                (value, key) => !_.isNumber(this.consumptionForm.declaredAnnualCons[key])
              )
            if (consNotDefined) {
                return false
            }
        }
        return true
    }

    updateForm() {
        this.onDispatch({ $event: { type: 'UPDATE_FORM_CONSUMPTION', consumptionForm: this.consumptionForm } })
    }

    submitFormConsumption() {
        if (this.store.isLandscapeDone) {
            this.consumptionForm.declaredAnnualCons = undefined
        }
        this.onDispatch({ $event: { type: 'UPDATE_FORM_CONSUMPTION', consumptionForm: this.consumptionForm } })
        this.onDispatch({ $event: { type: 'GET_QUOTATION', origin: 'FORM_INITIAL_BTN_ESTIMATE_QUOTATION' } })
        this.contractDraftService.getQuotation({ return: 'offer,timetable' }, this.consumptionForm)
        .$promise
        .then((quotationResult) => {
            this.onDispatch({ $event: { type: 'GET_QUOTATION_DONE', quotationResult } })
        })
        .catch((error) => {
            this.errorCatcher.catchError(error)
            this.onDispatch({ $event: { type: 'GET_QUOTATION_ERROR', error } })
        })
    }

    goBack() {
        this.onDispatch({ $event: { type: 'GO_TO_INITIAL' } })
    }

    onIconQuestionMarkClick() {
        const that = this
        this.$timeout(() => {
            if (that.popoverIsOpen) {
                that.onDispatch({ $event: { type: 'CLICK_ON_QUESTION_MARK_FORM_CONSUMPTION' } })
            }
        })
    }

    objectLength(obj) {
        return _.keys(obj).length
    }


}

export default {
    template: require('./quotationFormConsumption.jade')(),
    controller: QuotationFormConsumptionController,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationFormConsumption.js